import { useUpdate } from "react-use"
import { Check, UserPlus } from "lucide-react"

import { controllerConectaPro } from "../../../../services/controllers/service-activation";

import { Input } from "../../../../components/ui/Form/Input";
import { Action } from "../../../../components/ui/Action";

export function NewUser() {
  const CLConectaPro = controllerConectaPro()
  const update = useUpdate();

  return (
    <div className="flex flex-col gap-4 w-full p-4 bg-white rounded border border-zinc-200/40 shadow">
      <div className="flex flex-col gap-6 px-2 ">
        <h1 className="flex gap-4 items-center justify-start">
          <UserPlus className="w-6 h-6 text-scale-600" />
          <span className="text-lg font-semibold text-scale-600">Cadastrar usuário</span>
        </h1>
      </div>
      <div className="flex flex-col gap-6" key={Math.random()}>
        <form className="flex gap-4" onSubmit={(e) => CLConectaPro.saveNewUser(e, update)}>
          <Input.Root
            label="Nome do usuário"
            onChange={(name) => CLConectaPro.setNewUserProps({ name })}
          />
          <div className="w-64">
            <Input.Root
              label="Celular"
              mask="(99) 9 9999-9999"
              onChange={(cellphone) => CLConectaPro.setNewUserProps({ cellphone })}
            />
          </div>
          <Action.Root status="success" full>
            <Action.Icon icon={Check} size={18} strokeWidth={3} /> Salvar
          </Action.Root>
        </form>
        <div>
          <p>Para começar a usar o <strong>Conecta Pro</strong> na sua loja, <a href="https://chrome.google.com/webstore/detail/petland-crm-assistent/mcjmigdilehdcdkbkhjhicgmkpebcobl" target="_blank" className="text-scale-500 underline">clique aqui</a>  para acessar a página de instalação da extensão no seu navegdor.</p>
        </div>
      </div>
    </div>
  )
}
